import React from "react";
import Modal from "react-modal";
import PackageCategoryWatchdogForm from "./PackageCategoryWatchdogForm";
import PackageCategoryWatchdogSubscribed from "./PackageCategoryWatchdogSubscribed";

interface PackageCategoryWatchdogModalProperties {
    readonly packageCategoryId: number;
    readonly packageCategoryTitle: string;
    readonly onAfterClose: () => void;
}

export default function PackageCategoryWatchdogModal({
    packageCategoryId,
    packageCategoryTitle,
    onAfterClose,
}: PackageCategoryWatchdogModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(true);
    const [isSubscribed, setIsSubscribed] = React.useState(false);

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    const handleShowSuccessMessage = (): void => {
        setIsSubscribed(true);
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterClose={onAfterClose}
            onRequestClose={closeModal}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition"
        >
            <div className="modal-content">
                <div className="modal-header empty">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>
                <div className="modal-body">
                    {isSubscribed
                        ? <PackageCategoryWatchdogSubscribed
                            packageCategoryTitle={packageCategoryTitle} />
                        : <PackageCategoryWatchdogForm
                            packageCategoryId={packageCategoryId}
                            packageCategoryTitle={packageCategoryTitle}
                            onSubscribed={handleShowSuccessMessage}
                        />}
                </div>
            </div>
        </Modal>
    );
}
